import * as React from 'react';
import { Link } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import actionTypes from '../../../../actions/ActionTypes';
import ReadersSidebar from './ReadersSidebar';
import ReaderStore from '../../../../stores/ReadersStore';
import { LoadReaderMap, UpdateReaderMap, GetReadersAndFormTypes, DeleteMapping } from '../../../../actions/ReadersActions';

const customHistory = createBrowserHistory();

class ReaderMapping extends React.Component {
  constructor(props) {
    super(props);
    // state
    this.state = {
        currentReaderMap: {
            formTypeName: '',
            formTypeId: -1,
            mappings: [],
            readerId: -1,
            readerMapId: -1,
            readerName: '',
            fieldChoice: [],
          },
        newMode: false,
        allFormTypes: [],
        allReaders: [],
        matchError: '',
        deleteConfirm: false,
    };

    this.updateReaderMap = this.updateReaderMap.bind(this);
    this.onReaderChange = this.onReaderChange.bind(this);
    this.updateFieldMapping = this.updateFieldMapping.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.onSelectReader = this.onSelectReader.bind(this);
    this.onSelectFormType = this.onSelectFormType.bind(this);
    this.checkForUpdate = this.checkForUpdate.bind(this);
    this.validateReaderFormType = this.validateReaderFormType.bind(this);
    this.showDeleteConfirm = this.showDeleteConfirm.bind(this);
    this.deleteMapping = this.deleteMapping.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);

  }

  componentDidMount() {
    ReaderStore.addChangeListener(this.onReaderChange);
    this.updateReaderMap();
    document.title = 'TrinDocs - Readers'
  }

  componentWillUnmount() {
    ReaderStore.removeChangeListener(this.onReaderChange);
  }

  componentDidUpdate() {
    this.checkForUpdate();
  }

  updateReaderMap() {
    console.log('update');
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    if(pathParts[pathParts.length - 1] === 'new')
    {
      let newReaderMap = {
        formTypeName: '',
        formTypeId: -1,
        mappings: [],
        readerId: -1,
        readerMapId: -1,
        readerName: '',
        fieldChoice: [],
      }
      GetReadersAndFormTypes();
      this.setState({newMode: true, currentReaderMap: newReaderMap});
    } else {
      //this.setState({newMode: false});
      let readerMapId = parseInt(pathParts[pathParts.length - 1], 10);
      //console.log(path)

      //this.setState({newMode: false});
      LoadReaderMap(readerMapId);
    }


  }

  onReaderChange() {
    let lastAction = ReaderStore.getLastAction();
    if (lastAction === actionTypes.ReaderMapGet) {
        let map = ReaderStore.getReaderMap();
        this.setState({currentReaderMap: map, newMode: false});
    }
    if (lastAction === actionTypes.ReadersFormTypes) {
        let rft = ReaderStore.getReaderFormTypes();
        this.setState({allReaders: rft.readers, allFormTypes: rft.formTypes});
    }
    if (lastAction === actionTypes.ReaderMapUpdate) {
        let readerMap = ReaderStore.getReaderMap();
        console.log(readerMap);
        if(readerMap !== undefined)
        {
            this.setState({currentReaderMap: readerMap});
            let loc = window.location.pathname;
            let pathParts = loc.split('/');
            if(pathParts[pathParts.length - 1] === 'new')
              {
                customHistory.push(`/Admin/ReaderMap/${readerMap.readerMapId}`);
                this.setState({newMode: false});
              }

        }
      }
    if (lastAction === actionTypes.ReaderMapDelete) {
      let link = document.getElementById('readersHomeLink');
      link.click();
    }
  }

  showDeleteConfirm() {
    this.setState({deleteConfirm: true});
  }

  deleteMapping() {
    DeleteMapping(this.state.currentReaderMap);
  }

  cancelDelete() {
    this.setState({deleteConfirm: false});
  }


  updateFieldMapping(e, map)
  {
    let rm = this.state.currentReaderMap;
    let fc = this.state.currentReaderMap.fieldChoices.find(f => f.fieldId === parseInt(e.target.value,10));
    if(fc !== undefined)
    {
        map.fieldId = fc.fieldId;
        map.fieldName = fc.fieldName;
    }
    else {
        map.fieldId = -1;
        map.fieldName = 'Unassigned';
    }
    this.setState({currentReaderMap: rm, isDirty: true});
  }

  saveChanges() {
    let map = this.state.currentReaderMap;
    console.log(this.state.allReaders);
    console.log(map);
    let ft = this.state.allFormTypes.find(x => x.fieldId === map.formTypeId);
    console.log(ft);
    if(ft !== undefined) map.formTypeName = ft.fieldName;
    let r = this.state.allReaders.find(x => x.fieldId === map.readerId);
    console.log(r);
    if(r !== undefined) map.readerName = r.fieldName;
    UpdateReaderMap(map);
  }

  onSelectReader(e){
    let readerId = parseInt(e.target.value, 10);
    let crm = this.state.currentReaderMap;
    crm.readerId = readerId;
    this.setState({currentReaderMap: crm});
    this.validateReaderFormType(crm.readerId, crm.formTypeId);

  }

  validateReaderFormType(readerId, formTypeId)
  {
    if(readerId !== -1 && formTypeId !== -1) {
        let maps = ReaderStore.getReaderMaps();
        let match = false;

        maps.forEach((m) => {
            console.log(`${formTypeId}:${m.formTypeId}:${readerId}:${m.readerId}`);
            if(m.formTypeId === formTypeId && m.readerId === readerId)
            {
                match = true;
            }
        });
        if(match) {
            this.setState({matchError: 'This mapping already exist', isDirty: false})
        } else {
            this.setState({isDirty: true, matchError: ''});
        }

    } else {
        this.setState({isDirty: false, matchError: ''});
    }

  }

  onSelectFormType(e){
    let formTypeId = parseInt(e.target.value, 10);
    let crm = this.state.currentReaderMap;
    crm.formTypeId = formTypeId;
    this.setState({currentReaderMap: crm});
    this.validateReaderFormType(crm.readerId, crm.formTypeId);
  }

  checkForUpdate() {
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    let readerMapId = pathParts[pathParts.length - 1];
    let readerMapIdInt = parseInt(pathParts[pathParts.length - 1], 10);
    if (
        readerMapId === 'new' &&
      this.state.currentReaderMap !== undefined &&
      this.state.currentReaderMap.readerMapId !== -1
    ) {

      this.updateReaderMap();
    }
    if (readerMapId !== 'new' &&
      this.state.currentReaderMap !== undefined &&
      this.state.currentReaderMap.readerMapId !== readerMapIdInt
    ){
      this.updateReaderMap();
    }
  }


  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <ReadersSidebar />
          {this.state.currentReaderMap !== undefined && (
            <div
              className='flex-fill'
              style={{ backgroundColor: '#efefef', padding: '15px' }}
            >
                <div
                    className='card'
                    style={{
                    marginTop: '5px',
                    }}
                >
                    <div className='card-header'><h4 style={{float:'left'}}>Reader Mappings</h4>
                        {this.state.isDirty &&
                        <button className='btn btn-sm btn-success' style={{float: 'right'}} onClick={this.saveChanges}>Save Changes</button>
                        }
                    </div>
                    <div className='card-body mb-2'>
                        <table>
                            <tbody>
                                <tr>
                                    <td><span className='fs-4 display-6'>Reader:</span></td>
                                    <td>
                                        {!this.state.newMode && (
                                        <select className='form-select ms-1' disabled>
                                            <option>{this.state.currentReaderMap.readerName}</option>
                                        </select>
                                        )}
                                        {this.state.newMode && (
                                            <select className='form-select ms-1' value={this.state.currentReaderMap.readerId} onChange={(e) => this.onSelectReader(e)}>
                                                <option value='-1'>Select Reader</option>
                                                {this.state.allReaders.map((reader) => (
                                                    <option key={reader.fieldId} value={reader.fieldId}>{reader.fieldName}</option>
                                                ))}
                                            </select>
                                        )}
                                    </td>
                                    <td><span className='fs-4 display-6 ms-4'>Form Type:</span></td>
                                    <td>
                                        {!this.state.newMode && (
                                        <select className='form-select ms-1' disabled>
                                            <option>{this.state.currentReaderMap.formTypeName}</option>
                                        </select>
                                        )}
                                        {this.state.newMode && (

                                            <select className='form-select ms-1' value={this.state.currentReaderMap.formTypeId} onChange={(e) => this.onSelectFormType(e)}>
                                                <option value='-1'>Select Form Type</option>
                                                {this.state.allFormTypes.map((reader) => (
                                                    <option key={reader.fieldId} value={reader.fieldId}>{reader.fieldName}</option>
                                                ))}
                                            </select>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {this.state.matchError !== '' && <div className='alert alert-danger mt-3'>{this.state.matchError}</div>}
                        {!this.state.newMode && (<div>
                        <hr/>
                        <table>
                            <thead>
                                <tr>
                                    <td className='fs-4'>Reader Field:</td>
                                    <td width='30px'></td>
                                    <td className='fs-4 ms-4'>Form Type Field:</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.currentReaderMap.mappings.map((mapping) => (
                                    <tr key={mapping.readerFieldId}>

                                        <td>{mapping.readerFieldName}</td>
                                        <td></td>
                                        <td><select className='form-select ms-1' value={mapping.fieldId}
                                                onChange={(e) => this.updateFieldMapping(e, mapping)}
                                            >
                                            <option value='-1'>Unassigned</option>
                                            {this.state.currentReaderMap.fieldChoices.map((fc) => (
                                                <option key={fc.fieldId} value={fc.fieldId}>{fc.fieldName}</option>
                                            ))}

                                        </select></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>)}
                    </div>
                </div>
                {!this.state.newMode && !this.state.deleteConfirm && (
                <button className='btn btn-sm btn-danger mt-2' onClick={this.showDeleteConfirm}>Delete Map</button>
                )}
                {this.state.deleteConfirm &&
                <div className='alert alert-danger mt-2'>
                  This will delete the reader mapping and any of its configurations.  Do you want to continue?
                  <button className='btn btn-danger ms-2' onClick={this.deleteMapping}>Delete</button>
                  <button className='btn btn-secondary ms-2' onClick={this.cancelDelete}>Cancel</button>
                </div>
                }
            </div>
          )}
        </div>
        <Link
          id='readersHomeLink'
          to='/Admin/Readers'
          style={{ display: 'none' }}
        >
          HiddenLink
        </Link>
      </div>
    );
  }
}

export default ReaderMapping;
